<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Filter Physical Samples'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '400px' }"
        (onHide)="close()"
>
    <div class="flex flex-col gap-6 my-3">
        <!-- State Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="stateOptions"
                    [(ngModel)]="filters.state"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    id="ps-state"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%' }"
            ></p-multiSelect>
            <label for="ps-state">State</label>
        </p-ifta-label>

        <!-- Firmware Version Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="firmwareVersionOptions"
                    [(ngModel)]="filters.firmwareVersions"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    id="ps-firmware"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%' }"
                    [filter]="true"
            ></p-multiSelect>
            <label for="ps-firmware">Firmware Version</label>
        </p-ifta-label>

        <!-- Owner Dealership Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="ownerDealershipOptions"
                    [(ngModel)]="filters.ownerDealershipIds"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    id="ps-dealer"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%' }"
                    [filter]="true"
            ></p-multiSelect>
            <label for="ps-dealer">Owner Dealership</label>
        </p-ifta-label>

        <!-- Studio Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="studioOptions"
                    [(ngModel)]="filters.studioIds"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    id="ps-studio"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%' }"
                    [filter]="true"
            ></p-multiSelect>
            <label for="ps-studio">Studio</label>
        </p-ifta-label>

        <!-- Battery Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="batteryOptions"
                    [(ngModel)]="filters.batteryStatuses"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    id="ps-battery"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%' }"
                    [filter]="true"
            >
                <!-- Selected item template -->
                <ng-template #selectedItems let-selected>
                    <div class="flex flex-wrap gap-2">
                        <p-tag
                                *ngFor="let status of selected"
                                [value]="status.label"
                                [icon]="status.icon"
                                [severity]="status.severity"
                                class="text-xs"
                        ></p-tag>
                    </div>
                </ng-template>

                <!-- Dropdown item template -->
                <ng-template let-status #item>
                    <div class="flex items-center gap-2">
                        <p-tag
                                [value]="status.label"
                                [icon]="status.icon"
                                [severity]="status.severity"
                                class="text-xs"
                        ></p-tag>
                    </div>
                </ng-template>
            </p-multiSelect>
            <label for="ps-battery">Battery Status</label>
        </p-ifta-label>


        <!-- Sample Filter -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleOptions"
                    [(ngModel)]="filters.sampleIds"
                    optionLabel="printedName"
                    optionValue="id"
                    class="w-full"
                    appendTo="body"
                    id="ps-sample"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ width: '100%' }"
                    [filter]="true"
            >
                <!-- Selected item template -->
                <ng-template #selectedItems let-selectedSamples>
                    <div class="flex flex-wrap gap-2">
                        <div
                                *ngFor="let sample of selectedSamples"
                                class="flex items-center gap-2"
                        >
                            <img
                                    *ngIf="sample.media?.content?.cloudfrontUrl"
                                    [src]="sample.media.content.cloudfrontUrl"
                                    alt="{{ sample.printedName }}"
                                    class="w-5 h-5 object-cover rounded"
                            />
                            <span class="text-sm">{{ sample.printedName }}</span>
                        </div>
                    </div>
                </ng-template>

                <!-- Dropdown item template -->
                <ng-template let-sample #item>
                    <div class="flex items-center gap-2">
                        <img
                                *ngIf="sample.media?.content?.cloudfrontUrl"
                                [src]="sample.media.content.cloudfrontUrl"
                                alt="{{ sample.printedName }}"
                                class="w-6 h-6 object-cover rounded"
                        />
                        <div class="flex flex-col">
                            <span>{{ sample.printedName }}</span>
                            <small class="text-gray-500">{{ sample.detailNames }}</small>
                            <div class="flex items-center gap-2 mt-1">
                                <span class="text-xs text-gray-600">{{ sample.es2Key }}</span>
                                <p-tag
                                        [value]="sample.type?.name"
                                        severity="secondary"
                                        class="text-xs"
                                ></p-tag>
                                <p-tag
                                        [value]="sample.category?.name ?? 'No category'"
                                        severity="secondary"
                                        class="text-xs"
                                ></p-tag>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-multiSelect>
            <label for="ps-sample">Sample</label>
        </p-ifta-label>

    </div>

    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Reset"
                icon="pi pi-filter-slash"
                (click)="resetFilters()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Apply"
                icon="pi pi-check"
                (click)="applyFilters()"
        ></p-button>
    </div>
</p-dialog>
